const testimonials = [
  {
    name: "Jennifer K.",
    location: "West Des Moines, IA",
    text: "I found out my passport was expired three weeks before a work trip to Germany. Fast Passport Center got me sorted in 5 days. I shipped from the Des Moines UPS Store and had my passport back before I knew it.",
    service: "Expedited Renewal",
    days: "5 days",
  },
  {
    name: "Marcus T.",
    location: "Ankeny, IA",
    text: "My daughter needed her first passport for a school trip to France. I had no idea where to start. Fast Passport Center walked us through the acceptance clerk visit at the Johnston post office and handled everything after that.",
    service: "New Passport",
    days: "7 days",
  },
  {
    name: "Sarah L.",
    location: "Des Moines, IA",
    text: "Emergency situation — my passport was stolen two days before my flight to Mexico City. I called in a panic and they had a plan for me within an hour. Got my emergency passport the next day.",
    service: "Emergency Replacement",
    days: "24 hours",
  },
];

export default function DesMoinesTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Real Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Des Moines Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Iowa travelers trust Fast Passport Center for their most urgent passport needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white rounded-lg p-6 border border-gray-200">
              <div className="flex items-center gap-0.5 mb-4">
                {[...Array(5)].map((_, j) => (
                  <i key={j} className="ri-star-fill text-[#F6C344] text-sm"></i>
                ))}
              </div>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">"{t.text}"</p>
              <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <div className="text-right">
                  <span className="inline-block bg-[#EEF2F8] text-[#1A365D] text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">{t.service}</span>
                  <p className="text-gray-400 text-xs mt-1">{t.days}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}